module.exports = __webpack_public_path__ + "static/media/heroImage.51edff7c.jpg";